import $ from 'jquery';

export default function landingSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	$(function(){
		let videoElement = $('#hero').find('video');
		let video;

		if (videoElement.length) {
			video = videoElement[0];
			video.pause();
		}

		if ($('.landing').length > 0) {
			let bar = $('.landing .progressbar .bar');

			bar.animate({
				width: '100%'
			}, 1000, function(){
				setTimeout(()=>{

					$('.landing .logo').addClass('is-full');

					setTimeout(()=>{
						$('.landing').fadeOut(800, ()=>{
							$('.landing').remove();
						});

						if (videoElement.length) {
							video.play();
						}
					}, 700);
				}, 300);
			});
		} else {
			if (videoElement.length) {
				video.play();
			}
		}
	});
}



// WEBPACK FOOTER //
// ./source/scripts/sections/landing.js